<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 全部记录 -->
        <el-form-item>
          <el-button class="allRecord" type="primary" @click="goAllRecord">全部记录</el-button>
        </el-form-item>

        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`油气费汇总表`)">导出</el-button>
        </el-form-item>

        <!-- 过磅单导出 -->
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
            <i v-if="!btnloading" class="el-icon-folder"></i>
            导出
          </el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"></Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'oil',
      getListUrl: 'summarylist',
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.fleet,
        },
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "license", label: "车牌号" },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "doil_count", label: "加油单量", align: 'right', className: 'pr30' },
        { keyName: "doil", label: "现金加油金额", align: 'right', className: 'pr30' },
        { keyName: "moneydoil", label: "非现金加油金额", align: 'right', className: 'pr30' },
        { keyName: "summary_doil", label: "加油金额合计", align: 'right', className: 'pr30' },
      ],
      getTotalProperty: [
        'doil_count',
        'doil',
        'moneydoil',
        'summary_doil'
      ],
      btns: [
        {
          class: 'viewlistbtn',
          title: '查看列表',
          img: require('@/assets/img/icon_car_view.png'),
          unimg: require('@/assets/img/icon_car_view_hover.png'),
          cb: ({ month, license }) => {
            this.$router.push({
              path: `/finance/oilFee/cardorder`,
              query: {
                license,
                month,
                gsid: 2,
              }
            })
          },
        },
      ],
      baseParams: [
        'gsid',
        'month',
      ],
      btnloading: false,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `oil/expicture`;
      const params = {
        // userid: this.user.id,
        month: this.formInline.month,
        gsid: 2,
      }

      console.log(url, params)
      this.post(url, params, (res) => {
        this.btnloading = false
        // console.log(res)
        const { msg, url } = res
        if (msg === 'success' && url) {
          console.log(url)
          var link = document.createElement('a')
          link.href = url
          // link.download = "过磅单"
          link.click()
        } else {
          this.$message({
            message: msg || '导出失败，请稍后再试！',
            type: 'error',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },

    goAllRecord() {
      this.$router.push({
        path: `/finance/oilFee/cardorderall`,
        query: {
          month: this.formInline.month,
          gsid: this.formInline.gsid,
        }
      })
    },
  },
  created() { },
  mounted() {
    this.getFleet()
    // 定点加油配置id，固定不变
    this.$set(this.formInline, 'gsid', 2)
    this.$set(this.formInline, 'month', this.CURR_MONTH)
    this.MONTH = this.CURR_MONTH
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped></style>
